// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"347":"b90e5472","683":"9b997c87","701":"9b1582d3"}[chunkId] + ".css";
};